import { useAtomValue, useSetAtom } from 'jotai';

import { isViewingEngagementAtom } from '@/modules/insights/atoms';

import { trackEvent } from '../../../app/AppActions';
import { usePreferences } from '../../../react-query/usePreferences';
import { mixpanelEvents } from '../../../utils/mixpanel';
import { isDevDashboardAtom, selectedDashboardAtom } from '../atoms';
import type { Dashboard } from '../types';

import { InsightsNavItem } from './InsightsNavItem';

export const DashboardTabs = ({
  currentDashboard,
}: {
  currentDashboard: Dashboard;
}) => {
  const isViewingEngagement = useAtomValue(isViewingEngagementAtom);
  const setSelectedDashboard = useSetAtom(selectedDashboardAtom);
  const isDevDashboard = useAtomValue(isDevDashboardAtom);

  const handleDashboardButtonClick = (dashboard: Dashboard) => {
    setSelectedDashboard(dashboard);
    trackEvent(mixpanelEvents.tableauDashboardButtonClick, {
      dashboard,
      isDevDashboard,
    });
  };

  const { data: prefs } = usePreferences();
  const tableauInsightsEnabled = prefs?.enableInsights;

  if (!tableauInsightsEnabled) {
    return;
  }

  return (
    <>
      {tableauInsightsEnabled.includes('CLINICAL') && !isViewingEngagement && (
        <InsightsNavItem
          onClick={() => handleDashboardButtonClick('CLINICAL_MENTORING_BETA')}
          isSelected={currentDashboard === 'CLINICAL_MENTORING_BETA'}
        >
          Clinical Benchmarks
        </InsightsNavItem>
      )}
      {tableauInsightsEnabled.includes('HYGIENE') && !isViewingEngagement && (
        <InsightsNavItem
          onClick={() => handleDashboardButtonClick('HYGIENE_TASKS')}
          isSelected={currentDashboard === 'HYGIENE_TASKS'}
        >
          Operational Benchmarks
        </InsightsNavItem>
      )}
      {tableauInsightsEnabled.includes('ENGAGEMENT') && isViewingEngagement && (
        <InsightsNavItem
          onClick={() => handleDashboardButtonClick('ENGAGEMENT')}
          isSelected={currentDashboard === 'ENGAGEMENT'}
        >
          Engagement
        </InsightsNavItem>
      )}
    </>
  );
};
